export default {
  items: [
    {
      name: "Waiting for Approval",
      url: "/waiting_for_approval",
      icon: "fa fa-hourglass fa-lg",
      children: [
        {
          name: "Mobile requests",
          url: "/waiting_for_approval/mobile",
          icon: "fa fa-mobile fa-lg",
          attributes: { "data-cy": "mobile-wfa" },
        },
        {
          name: "Desktop requests",
          url: "/waiting_for_approval/desktop",
          icon: "fa fa-laptop fa-lg",
          attributes: { "data-cy": "desktop-wfa" },
        },
      ],
    },
    {
      name: "Mobile Users",
      url: "/mobile-users",
      icon: "fa fa-tablet fa-lg",
      attributes: { "data-cy": "mobile-users" },
    },
    {
      name: "Desktop Users",
      url: "/desktop-users",
      icon: "fa fa-tv fa-lg",
      attributes: { "data-cy": "desktop-users" },
    },
    {
      name: "Key recovery requests",
      url: "/key_recovery_requests",
      icon: "fa fa-repeat fa-lg",
    },
    {
      name: "KYC Limit Amount",
      url: "/kyc-limit-amount",
      icon: "fa fa-gears fa-lg",
      attributes: { "data-cy": "kyc-limit-amount" },
      children: [
        {
          name: "Add Limit",
          url: "/kyc-limit-add",
          icon: "fa fa-gear fa-lg",
          attributes: { "data-cy": "add-limit" },
        },
        {
          name: "Mobile Limit",
          url: "/kyc-limit-amount/mobile-limit",
          icon: "fa fa-gear fa-lg",
          attributes: { "data-cy": "mobile-limit" },
        },
        {
          name: "Desktop Limit",
          url: "/kyc-limit-amount/desktop-limit",
          icon: "fa fa-gear fa-lg",
          attributes: { "data-cy": "desktop-limit" },
        },
      ],
    },
    {
      name: "Merchants",
      url: "/merchant",
      icon: "fa fa-map fa-lg",
      attributes: { "data-cy": "merchants" },
      children: [
        {
          name: "Merchants list",
          url: "/merchants",
          icon: "fa fa-map-marker fa-lg",
          attributes: { "data-cy": "merchants-list" },
        },
        {
          name: "Merchant requests",
          url: "/merchant-requests",
          icon: "fa fa-map-marker fa-lg",
          attributes: { "data-cy": "merchants-requests" },
        },
      ],
    },
    {
      name: "Users",
      url: "/users",
      icon: "fa fa-users fa-lg",
      attributes: { "data-cy": "roles-list" },
    },
    {
      name: "Roles",
      url: "/role",
      icon: "fa fa-stop-circle fa-lg",
      attributes: { "data-cy": "merchants" },
      children: [
        {
          name: "Roles list",
          url: "/roles",
          icon: "fa fa-address-book fa-lg",
          attributes: { "data-cy": "roles-list" },
        },
        {
          name: "Pages",
          url: "/pages",
          icon: "fa fa-stop-circle fa-lg",
          attributes: { "data-cy": "roles-list" },
        },
      ],
    },
    {
      name: "Change Phone Requests",
      url: "/change-phone-requests-admin",
      icon: "fa fa-dashboard fa-lg",
      attributes: { "data-cy": "change-phone-requests" },
    },
    {
      name: "Bank contact information",
      url: "/view_bank_info",
      icon: "fa fa-info-circle fa-lg",
      attributes: { "data-cy": "bank-info" },
    },
    {
      name: "Terms & Conditions",
      url: "/terms_and_conditions",
      icon: "fa fa-stop-circle fa-lg",
      attributes: { "data-cy": "merchants" },
      children: [
        {
          name: "Mobile terms",
          url: "/terms_and_conditions/mobile",
          icon: "fa fa-address-book fa-lg",
          attributes: { "data-cy": "roles-list" },
        },
        {
          name: "Desktop terms",
          url: "/terms_and_conditions/desktop",
          icon: "fa fa-stop-circle fa-lg",
          attributes: { "data-cy": "roles-list" },
        },
      ],
    },
  ],
};
